import API from './axios.js';


export const getClientCompanyData = () =>API.get(`clients/company`);
export const updateClientCompanyData = (id,payload) =>API.put(`clients/${id}`,payload);